import { useStore } from 'vuex'
export default {
    name: 'TheHeader',
    setup() {
        const store = useStore()
        const startBurgermenu = function (e) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'BurgerMenu',
                returnTarget: e.currentTarget
            })
        }

        const startProfileOverlay = function (e) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'ProfileOverlay',
                returnTarget: e.currentTarget
            })
        }

        const startSearchoverlay = function (e) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'SearchOverlay',
                returnTarget: e.currentTarget
            })
        }

        const startDonationFlow = function (e) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'personalDonation',
                returnTarget: e.currentTarget
            })
        }


        const showStafetRoundCounter = document.location.hash.indexOf('stafetTeamRoundCounter') !== -1
        const showDonationReceipt = document.location.hash.indexOf('personalDonationReceipt') !== -1
        const showStafetTeamSignupReceipt = document.location.hash.indexOf('stafetTeamSignupReceipt') !== -1
        const showStafetTeamCreationReceipt = document.location.hash.indexOf('stafetTeamCreationReceipt') !== -1
        const showStafetTeamUpdateReceipt = document.location.hash.indexOf('stafetTeamUpdateReceipt') !== -1
        const showCreateHold = document.location.hash.indexOf('createTeam') !== -1           
        const showProfileDeleted = document.location.hash.indexOf('profileDeleted') !== -1         
        const showChangesSaved = document.location.hash.indexOf('changesSaved') !== -1         
        const showProfileCreated = document.location.hash.indexOf('tilmeldProfilKvittering') !== -1         
        const showStafetDonationReceipt = document.location.hash.indexOf('donationReceiptOverlay') !== -1       
        const showDeleteCancerProfileModal = document.location.hash.indexOf('deleteCancerProfileModal') !== -1  
        const showDeletePostOverlay = document.location.hash.indexOf('DeletePostOverlay') !== -1
        const showDeleteCommentOverlay = document.location.hash.indexOf('DeleteCommentOverlay') !== -1
        const showDeleteEventModal = document.location.hash.indexOf('deleteEventModal') !== -1
        const showFrivilligeShopWrongRoleModal = document.location.hash.indexOf('frivilligeShopWrongRoleModal') !== -1
        const showCalendarOverlay = document.location.hash.indexOf('calendarOverlay') !== -1
        const showLoginOverlay = document.location.hash.indexOf('LoginOverlay') !== -1
        const showProfileEditedOverlay = document.location.hash.indexOf('ProfileEditedOverlay') !== -1
        const showDeleteGlobalProfileOverlay = document.location.hash.indexOf('DeleteGlobalProfileOverlay') !== -1
        const showStafetMailEditorOverlay = document.location.hash.indexOf('stafetMailEditorOverlay') !== -1

        if (showDonationReceipt) {
            store.dispatch('fundraising/showReceipt')
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'personalDonation'
            })
        } else if (showStafetTeamSignupReceipt) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'tilmeldHoldKvittering'
            })
        } else if (showStafetTeamCreationReceipt) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'HoldOprettelseKvittering'
            })
        } else if (showStafetRoundCounter) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'HoldetsRoundCounterOverlay'
            })
        } else if (showStafetTeamUpdateReceipt){
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'HoldRedigerKvittering'
            })
        } else if (showCreateHold){
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'OpretHoldOverlay'
            })
        } else if (showProfileDeleted) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'ProfileDeleted'
            })
        } else if (showChangesSaved) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'ChangesSaved'
            })
        }
        else if (showProfileCreated) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'tilmeldProfilKvittering'
            })
        }        
        else if (showStafetDonationReceipt) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'donationReceiptOverlay'
            })
        }
        else if (showDeleteCancerProfileModal) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'DeleteCancerProfileModal'
            })
        }
        else if (showDeletePostOverlay) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'DeletePostOverlay'
            })
        }
        else if (showDeleteCommentOverlay) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'DeleteCommentOverlay'
            })
        }
        else if (showDeleteEventModal) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'DeleteEventModal'
            })
        }
        else if (showFrivilligeShopWrongRoleModal) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'FrivilligeShopWrongRoleModal'
            })
        }
        else if (showCalendarOverlay) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'CalendarOverlay'
            })
        }
        else if (showLoginOverlay) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'LoginOverlay'
            })
        } 
        else if (showProfileEditedOverlay) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'ProfileEditedOverlay'
            })
        } 
        else if (showDeleteGlobalProfileOverlay) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'DeleteGlobalProfileOverlay'
            })
        } 
        else if (showStafetMailEditorOverlay) {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'StafetMailEditorOverlay'
            })
        } 

        return {
            startBurgermenu,
            startProfileOverlay,
            startSearchoverlay,
            startDonationFlow
        }
    }
}
